import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router/composables";
import i18n from "../i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const message = ref<string>('')
const snackbar = ref<boolean>(false)

onMounted(() => {
  //@ts-ignore
  if (route.query.message) {
    //@ts-ignore
    displayMessage(route.query.message)
  }
  router.replace(router.currentRoute.path)
})

const displayMessage = (messageString:string) => {
  message.value = messageString
  snackbar.value = true
}

return { __sfc: true,router, route, message, snackbar, displayMessage, i18n }
}

})